// HomePage-v2.0.0.jsx - Version: 2.0.0 - Created: 2024-12-08
import React from 'react'
import { Link } from 'react-router-dom'
import './HomePage-v2.0.0.css'

const HomePage = () => {
  const features = [
    {
      icon: '🎓',
      title: 'آموزش تعاملی',
      description: 'یادگیری شطرنج با بازی‌های سرگرم‌کننده و تعاملی',
      link: '/academy',
      color: '#4FC3F7'
    },
    {
      icon: '🎮',
      title: 'بازی آنلاین',
      description: 'بازی با دوستان و ربات‌های هوشمند در سطوح مختلف',
      link: '/playground',
      color: '#81C784'
    },
    {
      icon: '🎯',
      title: 'تمرین هوشمند',
      description: 'تمرین‌های متنوع برای تقویت مهارت‌های شطرنج',
      link: '/practice',
      color: '#FFB74D'
    },
    {
      icon: '📊',
      title: 'پیگیری پیشرفت',
      description: 'مشاهده رشد مهارت‌ها و دریافت گزارش‌های دقیق',
      link: '/parents',
      color: '#BA68C8'
    }
  ]

  const testimonials = [
    {
      name: 'پدر امیرعلی',
      text: ' پسرم در کمتر از یک ماه توانست اصول شطرنج رو یاد بگیره و حالا با اعتماد به نفس بازی می‌کنه!',
      child: 'امیرعلی، ۸ ساله'
    },
    {
      name: 'مادر ستایش',
      text: ' محیط بسیار امن و جذابی برای کودکان ایجاد شده. ستایش هر روز مشتاقانه منتظر تمرین شطرنجش هست.',
      child: 'ستایش، ۹ ساله'
    }
  ]

  return (
    <div className="homepage-v2">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">
            شطرنج رو مثل <span className="highlight">بازی</span> یاد بگیر!
          </h1>
          <p className="hero-subtitle">
            پلتفرم آموزشی شطرنج برای کودکان ۶ تا ۱۲ سال
            <br />
            یادگیری آسان، سریع و لذت‌بخش
          </p>
          <div className="hero-actions">
            <Link to="/academy" className="hero-button primary-button">
              شروع یادگیری رایگان
            </Link>
            <Link to="/practice" className="hero-button secondary-button">
              مشاهده تمرین‌ها
            </Link>
          </div>
        </div>
        <div className="hero-visual">
          <div className="chess-animation">
            <div className="chess-piece king">♚</div>
            <div className="chess-piece queen">♛</div>
            <div className="chess-piece bishop">♝</div>
            <div className="chess-piece knight">♞</div>
            <div className="chess-board">
              {/* تخته شطرنج انیمیشنی */}
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <h2 className="section-title">چرا Chess4Kids؟</h2>
          <div className="features-grid">
            {features.map((feature, index) => (
              <Link key={index} to={feature.link} className="feature-card">
                <div 
                  className="feature-icon"
                  style={{ backgroundColor: feature.color }}
                >
                  {feature.icon}
                </div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
                <div className="feature-arrow">→</div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section">
        <div className="container">
          <h2 className="section-title">نظرات والدین</h2>
          <div className="testimonials-grid">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-card">
                <div className="testimonial-content">
                  <p>"{testimonial.text}"</p>
                </div>
                <div className="testimonial-author">
                  <strong>{testimonial.name}</strong>
                  <span>{testimonial.child}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <h2>همین حالا سفر شطرنجی خودت رو شروع کن!</h2>
          <p>به جامعه ۱۰۰۰+ کودک شطرنج‌باز ما بپیوند</p>
          <div className="cta-actions">
            <Link to="/academy" className="cta-button primary-button large">
              شروع دوره رایگان
            </Link>
            <Link to="/parents" className="cta-button secondary-button large">
              اطلاعات بیشتر
            </Link>
          </div>
          <div className="stats">
            <div className="stat">
              <strong>۱,۲۰۰+</strong>
              <span>کودک عضو</span>
            </div>
            <div className="stat">
              <strong>۸۵%</strong>
              <span>رضایت والدین</span>
            </div>
            <div className="stat">
              <strong>۵۰۰+</strong>
              <span>تمرین تعاملی</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default HomePage